module.exports = __webpack_public_path__ + "img/ring_g_s_1_null@2x.e66fe737.png";